// ChatEnableContext.js
import React, { createContext, useState, useContext } from 'react';

const ChatEnableContext = createContext();

export const useChatEnable = () => useContext(ChatEnableContext);

export const ChatEnableProvider = ({ children }) => {
    const [isChatEnable, setIsChatEnable] =
        useState(localStorage.getItem("ChatEnable") === 'enable' ? true : false);

    const toggleChatEnable = () => {
        setIsChatEnable(prevMode => !prevMode);
        localStorage.setItem("enable", isChatEnable ? 'enable' : 'disable');
    };

    return (
        <ChatEnableContext.Provider value={{ isChatEnable, toggleChatEnable }}>
            {children}
        </ChatEnableContext.Provider>
    );
};
